import { useTranslation } from 'react-i18next';

import Text from '../../../../../shared/Text';
import { Button } from '../../../../../shared/FormStyles/Button';
import { useUndoQuestionStatus } from '../../data.jsx';

function Undo({
  message,
  questionId,
  activeTab,
  tileId,
  sortBy,
  sortDirection,
  handleClose,
}) {
  const { mutate } = useUndoQuestionStatus({
    activeTab,
    tileId,
    sortBy,
    sortDirection,
  });
  const { t } = useTranslation('reports');

  const updateStatus = () => {
    mutate({ questionId });
    handleClose();
  };

  return (
    <div>
      <Text variant="subtitle2">{message}</Text>
      <Button onClick={updateStatus} variant="outlinedBlue" mt="12px">
        {t('questionsTable.undo')}
      </Button>
    </div>
  );
}

export default Undo;
